import { render, staticRenderFns } from "./iconSteps.vue?vue&type=template&id=bda99abe"
import script from "./iconSteps.vue?vue&type=script&lang=js"
export * from "./iconSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports